import { Routes } from '@angular/router';
import { isLoggedIn } from '../auth/isLogin.guard';
// import { isLoggedIn } from '../auth/isLogin.guard';

//Route for content layout without sidebar, navbar and footer for pages like Login, Registration etc...

export const CONTENT_ROUTES: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('../../pages/login/login.module').then((m) => m.LoginModule),
    canActivate: [isLoggedIn],
  },
];
